export default "__VITE_ASSET__2923ac41__"